import { HTMLFormFieldElement } from '@/js/UI/naja/PdFormsAjaxValidationExtension'

const defaultConditionalContainerStatus = ['STATUS_UNKNOWN_EMAIL']

function toggleContainer(container: HTMLElement | null, isHidden: boolean) {
	if (container === null) {
		return
	}

	const inputs = container.querySelectorAll<HTMLFormFieldElement>('input, select, textarea, button')

	container.hidden = isHidden
	inputs.forEach((input) => {
		input.disabled = isHidden
	})
}

export function personalDeliveryEmailValidatorCallback(elem: HTMLFormFieldElement, payload: any) {
	if (elem.dataset.pdformsConditionalContainer !== undefined) {
		const dataStatus = elem.dataset.pdformsConditionalContainerStatus
		const statusArray = dataStatus ? (JSON.parse(dataStatus) as string[]) : defaultConditionalContainerStatus

		toggleContainer(
			document.getElementById(elem.dataset.pdformsConditionalContainer),
			!statusArray.includes(payload.status)
		)
	}

	// Souhlas s newsletterem nabídneme jen tomu, kdo ho v CRM explicitně odmítl - na rozdíl od kontejneru výše
	// se neřídí statusem, ale samostatným příznakem z odpovědi.
	if (elem.dataset.pdformsNewsletterContainer !== undefined) {
		toggleContainer(
			document.getElementById(elem.dataset.pdformsNewsletterContainer),
			!payload.newsletterConsentVisible
		)
	}
}
